import { render, staticRenderFns } from "./removal-list.vue?vue&type=template&id=bad65b4a"
import script from "./removal-list.vue?vue&type=script&lang=js"
export * from "./removal-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports